// export const CHAT_TOKEN_EXPIRE_TIME = 7000;
// export const CHAT_TOKEN_EXPIRE_TIME_TO_CHECK = 6999;
export const CHAT_TOKEN_EXPIRE_TIME = 1000000000000;
export const CHAT_TOKEN_EXPIRE_TIME_TO_CHECK = 1000000000000;